module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<fieldset><legend>'+
((__t=( i18n.tc("SubscriptionTerminateVerification", "Terminate subscription") ))==null?'':__t)+
'</legend> ';
 if ( "terminate" === ending ) { 
__p+=' <p>'+
((__t=( i18n.tc("SubscriptionTerminateVerification", "You have selected to terminate the subscription immediately.") ))==null?'':__t)+
'</p> ';
 } 
__p+=' ';
 if ( "deactivate" === ending ) { 
__p+=' <p>'+
((__t=( i18n.tc("SubscriptionTerminateVerification", "You have selected to terminate the subscription on %s." ).format( renewalDate) ))==null?'':__t)+
'</p> ';
 } 
__p+=' <p>'+
((__t=( i18n.tc( "SubscriptionTerminateVerification", "Are you sure you want to terminate the subscription for the %1$s in %2$s? This step is final and cannot be reversed." ).format(unitType, transientAlias) ))==null?'':__t)+
'</p></fieldset><fieldset class="button-wrap"><button data-click="verification-cancel">'+
((__t=( i18n.tc("SubscriptionTerminateVerification", "Cancel") ))==null?'':__t)+
'</button> <button class="danger" data-click="verification-submit">'+
((__t=( i18n.tc("SubscriptionTerminateVerification", "Terminate") ))==null?'':__t)+
'</button></fieldset>';
}
return __p;
};
